








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponetsOrdersComponetsOrderHeader extends Vue {
  @Prop({ type: String, default: 'Оформление заявки' })
  defaultText: string;

  @Prop({ type: String, default: '' })
  title: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/orders/OrderHeader.vue